import BaseModal from '@/components/modal';
import Drawer from '@/components/drawer';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import useDeviceType from '@/hooks/useDeviceType';
import styles from './index.module.scss';
import { Button, ConfigProvider } from 'antd';
import { observer } from 'mobx-react';
import { getPointsExpirationDateExample } from '@/utils/date';

const Modal = NiceModal.create(({ validMonths }: { validMonths: number }) => {

  const { visible, hide } = useModal();
  const { isMobile } = useDeviceType();

  const handleCancel = (e: any) => {
    hide();
  }

  if (!validMonths) {
    return null;
  }

  const Content = (
    <div className={styles.points_tips_content}>
      <div className={styles.title}>Points Expire in {validMonths} {validMonths === 1 ? 'Month' : 'Months'}</div>
      <div className={styles.content}>
        <div>
          Points are valid for {validMonths} calendar {validMonths === 1 ? 'month' : 'months'} from the day you earn them.
        </div>
        <div>
          You&apos;ll get a reminder 30 days before any points expire.
        </div>
        <div className={styles.subTitle}>
          Example:
        </div>
        <div>
          {getPointsExpirationDateExample(validMonths)}
        </div>
        <div className={styles.returnPoints}>
          Returned points from refunds keep their original expiration date.
        </div>
      </div>
      <div className={styles.footer}>
        <Button type='primary' onClick={handleCancel} className={styles.button}>OK</Button>
      </div>
    </div>
  )

  if (isMobile) {
    return (
      <ConfigProvider
        wave={{ disabled: true }}
        theme={{ token: typeof window !== 'undefined' ? window?.__WEB_SITE_APP_CONFIG?.antdToken || {} : {} }}
      >
        <Drawer
          className={styles.points_tips_drawer}
          footer={null}
          open={visible}
          onClose={handleCancel}
          placement='bottom'
          height='auto'
          maskClosable={false}
          closable={false}
        >
          {Content}
        </Drawer>
      </ConfigProvider>
    )
  }

  return (
    <BaseModal
      className={styles.points_tips_modal}
      closable={false}
      isOpen={visible}
      footer={null}
      onCancel={handleCancel}>
      {Content}
    </BaseModal>
  )
})

export default observer(Modal); 